import { FieldNumberOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation/initYup.ts';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference.ts';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule.ts';
import { FractionDigitsRule } from '../../../../rules/repository/fraction-digits/FractionDigits.rule.ts';
import { IntegerRule } from '../../../../rules/repository/integer/Integer.rule.ts';
import { PositiveRule } from '../../../../rules/repository/positive/Positive.rule.ts';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule.ts';
import { TotalDigitsRule } from '../../../../rules/repository/total-digits/TotalDigits.rule.ts';
import { ValueRangeRule } from '../../../../rules/repository/value-range/ValueRange.rule.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema.ts';
import { createCommonFormSchema } from '../common/createCommonFormSchema.ts';
import { type INumberWidget } from './INumberWidget.ts';
import { NumberWidgetComponent } from './NumberWidgetComponent.tsx';
import {
  NumberWidgetConfigComponent,
  NumberWidgetConfigSchema,
} from './NumberWidgetConfigComponent.tsx';

export const NumberWidgetType: IWidgetType<INumberWidget> = {
  type: WidgetType.Number,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  name: 'Campo numerico',
  icon: <FieldNumberOutlined />,
  hasValue: true,
  getReference: getSimpleWidgetReference(Datatype.Number),
  formComponent: NumberWidgetComponent,
  createFormSchema: ({ widget }) =>
    // TODO al momento i gli input impostano null all'onClear, dando problemi di validazione ai campi opzionali (non nullabili di default).
    // Utilizzare gli undefined come valori per l'onClear on sembra immediato a causa della gestione dei valori negli input di antd.
    createCommonFormSchema(yup.number().notRequired(), widget),
  previewComponent: NumberWidgetComponent,
  configValidator: NumberWidgetConfigSchema,
  configComponent: NumberWidgetConfigComponent,
  translationSchema: InputCommonTranslationSchema,
  rules: [
    RequiredRule,
    ValueRangeRule,
    IntegerRule,
    FractionDigitsRule,
    PositiveRule,
    TotalDigitsRule,
    CustomWarningsRule,
  ],
};
